// @flow
import React, { Component } from "react";
import Header from "../Header/Header";
import { Redirect } from "react-router";
import Translator from "../../components/Translator";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ErrorHandler from "../ErrorHandler/ErrorHandler";
import * as Sentry from "@sentry/browser";
import i18next from "i18next";
// hab mich für das nicht-transparente entschieden, da das transparente bild komplett schwarzen hintergrund hatte.
import image from "./roomInformation/Place_card.gif";
import imageMunich from "./roomInformation/Place_card.png";
import { getLocationId, getLocationTranslationKey } from "../../themes";

export const requestKeyCard = (
    apiClient,
    reservation,
    roomNr,
    checkIn,
    checkOut,
    cardNum,
    successCallback,
    failureCallback,
    showErrorMessage,
): void => {
    const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";
    const errorNamespace = manuelCardWorkflow ? "errors_manual" : "errors";

    apiClient
        .requestKeyCard(roomNr, checkIn, checkOut, cardNum)
        .then((response) => {
            Sentry.addBreadcrumb({
                message: "Reservation " + (reservation?.id ?? "-") + " keycard created",
            });

            if (typeof response === "undefined" || response === null) {
                response = {
                    error: "createcard",
                };
                Sentry.captureEvent({
                    message: "Response was null or undefined",
                });
            }

            if (response.error) {
                let errorTitle = "messages.errors.errorTitle";
                let errorMsg = "roominformation.errors.createcard";

                if (typeof response.reason !== "undefined") {
                    switch (response.reason) {
                        case 4096:
                        case 4098:
                        case 4099:
                        case 4100:
                        case 4101:
                        case 4103:
                        case 8194:
                            if (manuelCardWorkflow) {
                                errorTitle = "messages.errors.errorTitles.manuallyKeycard.timeout";
                            }
                            errorMsg = `roominformation.${errorNamespace}.${response.reason}`;
                            break;
                        default:
                            if (manuelCardWorkflow) {
                                errorTitle = "messages.errors.errorTitles.manuallyKeycard.general";
                            }
                            errorMsg = `roominformation.${errorNamespace}.createcard`;
                            break;
                    }
                }
                showErrorMessage(errorMsg, errorTitle);
                failureCallback();
            } else {
                Sentry.addBreadcrumb({
                    message: "Reservation " + (reservation?.id ?? "-") + " roominformation => call callback",
                });
                successCallback();
            }
        })
        .catch((err) => {
            // FIXME: unhandled Exception
            Sentry.captureException(err);
            failureCallback();
        });
};

class RoomInformation extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errorMessage: "",
            errorTitle: "",
            showErrorMessage: false,
            isSpinnerVisible: false,
            cardCount: 1,
        };

        this.submitRequestKeyCard = this.submitRequestKeyCard.bind(this);
    }

    makeKeyCardRequest(roomNr, checkIn, checkOut, cardNum, successCallback, failureCallback) {
        requestKeyCard(
            this.props.apiClient,
            this.props.reservation,
            roomNr,
            checkIn,
            checkOut,
            cardNum,
            successCallback,
            failureCallback,
            (translationId, errorTitle) => this.showErrorMessage(translationId, errorTitle),
        );
    }

    redirectToFinish(roomNumber, cardCount) {
        const redirectToThankYouOnFinish = this.props.location.state?.redirectToThankYouOnFinish ?? false;
        if (redirectToThankYouOnFinish) {
            this.props.history.push({ pathname: "/main/thankyou" });
        } else {
            this.props.history.push(
                {
                    pathname: "keycard",
                },
                {
                    roomNumber: roomNumber,
                    cardCount: cardCount,
                },
            );
        }
        this.setState({ isSpinnerVisible: false });
    }

    submitRequestKeyCard() {
        this.setState({ isSpinnerVisible: true });

        const baseMsg = "Reservation " + (this.props.reservation?.id ?? "-");
        Sentry.addBreadcrumb({ message: baseMsg + " create keycard" });

        const twoCardsAllowed = this.props.reservation?._meta?.twoCardsAllowed ?? false;
        const roomNr = String(this.props.location.state?.roomname ?? "");
        const isSecondRequest = this.props.location.state?.isSecondRequest ?? false;
        const checkIn = this.props.reservation.arrival;
        const checkOut = this.props.reservation.departure;
        const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";
        const cardCount = this.state.cardCount;

        this.makeKeyCardRequest(
            roomNr,
            checkIn,
            checkOut,
            isSecondRequest ? 2 : 1,
            () => {
                if (!twoCardsAllowed || cardCount === 1) {
                    Sentry.addBreadcrumb({
                        message: baseMsg + " callback: on card only",
                    });
                    this.redirectToFinish(this.props.location.state?.roomname, cardCount);
                } else if (manuelCardWorkflow && isSecondRequest) {
                    Sentry.addBreadcrumb({
                        message: baseMsg + " callback: manual second done",
                    });
                    this.redirectToFinish(this.props.location.state?.roomname, cardCount);
                } else if (manuelCardWorkflow) {
                    Sentry.addBreadcrumb({
                        message: baseMsg + " callback: manual do second",
                    });
                    this.reloadPage(roomNr);
                } else {
                    Sentry.addBreadcrumb({
                        message: baseMsg + " callback: not manual do second",
                    });
                    this.makeKeyCardRequest(
                        roomNr,
                        checkIn,
                        checkOut,
                        2,
                        () => {
                            Sentry.addBreadcrumb({
                                message: baseMsg + " callback: not manual second done",
                            });
                            this.redirectToFinish(this.props.location.state?.roomname, cardCount);
                        },
                        () => this.setState({ isSpinnerVisible: false }),
                    );
                }
            },
            () => this.setState({ isSpinnerVisible: false }),
        );
    }

    reloadPage(roomNr) {
        const redirectToThankYouOnFinish = this.props.location.state?.redirectToThankYouOnFinish ?? false;
        this.props.history.push(
            {
                pathname: "roominformation",
            },
            {
                roomname: roomNr,
                isSecondRequest: true,
                redirectToThankYouOnFinish: redirectToThankYouOnFinish,
            },
        );
        this.setState({ isSpinnerVisible: false });
    }

    showErrorMessage(translationId, errorTitle) {
        this.setState({
            errorMessage: translationId,
            errorTitle: errorTitle,
            showErrorMessage: true,
        });
        setTimeout(() => {
            this.setState({ showErrorMessage: false });
        }, 8000);
    }

    render() {
        if (!this.props.reservation) {
            return <Redirect to={"/"} refresh={true} />;
        }

        const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";
        const isSecondRequest = this.props.location.state?.isSecondRequest ?? false;
        const twoCardsAllowed = this.props.reservation?._meta?.twoCardsAllowed ?? false;
        const printerBroken = localStorage.getItem("printerBroken") === "true";
        const textKey = this.buildTextKey(twoCardsAllowed, printerBroken);

        // TODO[manuell]: changes because we are in state isSecondRequest

        const roomNumber = manuelCardWorkflow ? (
            <img className="room-number-image"
                 src={getLocationId() === "MUC_OP" ? imageMunich : image}
                 alt={"Place Card"} />
        ) : (
            <div className="room-number-inner">{this.props.location.state?.roomname ?? "TEST"}</div>
        );

        return (
            <div className="page-roominformation">
                {this.state.showErrorMessage ? (
                    <ErrorHandler
                        customMessage={{
                            title: <Translator content={this.state.errorTitle} />,
                            body: (
                                <Translator
                                    content={this.state.errorMessage}
                                    with={{
                                        hotlineNumber: localStorage.getItem("hotline"),
                                    }}
                                />
                            ),
                        }}
                    />
                ) : (
                    false
                )}
                <LoadingSpinner isSpinnerVisible={this.state.isSpinnerVisible} />
                <div className="page-inner-wrapper">
                    <Header headerTitle={getLocationTranslationKey(this.buildPageTitleKey(twoCardsAllowed))} />
                    <div className="content-wrapper">
                        <div className="container">
                            <div className="room-information">
                                <div className="row">
                                    <div className="col-6">
                                        <div className="room-number">{roomNumber}</div>
                                    </div>
                                    <div className="col-6">
                                        <div className="room-information-text">
                                            <h2 className="h2-heading">
                                                <Translator content={this.buildHeadlineKey()} />
                                            </h2>
                                            {textKey && (
                                                <div className={printerBroken ? "h2-heading" : "description"}>
                                                    <Translator content={textKey} />
                                                </div>
                                            )}

                                            {twoCardsAllowed && !isSecondRequest && (
                                                <div className="custom-radio-container-wrap">
                                                    <label
                                                        htmlFor="travelReason-leisure"
                                                        className="custom-radio-container"
                                                    >
                                                        <Translator
                                                            className="__label"
                                                            content="checkin.radioButton.one"
                                                        />
                                                        <input
                                                            type="radio"
                                                            name="travelReason"
                                                            id="travelReason-leisure"
                                                            value={"leisure"}
                                                            checked={this.state.cardCount === 1}
                                                            onChange={() => {
                                                                this.setState({ cardCount: 1 });
                                                            }}
                                                        />
                                                        <span className="__checkmark" />
                                                    </label>
                                                    <label
                                                        htmlFor="travelReason-business"
                                                        className="custom-radio-container"
                                                    >
                                                        <Translator
                                                            className="__label"
                                                            content="checkin.radioButton.two"
                                                        />
                                                        <input
                                                            type="radio"
                                                            name="travelReason"
                                                            id="travelReason-business"
                                                            value={"business"}
                                                            checked={this.state.cardCount === 2}
                                                            onChange={() => {
                                                                this.setState({ cardCount: 2 });
                                                            }}
                                                        />
                                                        <span className="__checkmark" />
                                                    </label>
                                                </div>
                                            )}

                                            <button
                                                onClick={this.submitRequestKeyCard}
                                                className="btn btn-stayery-black btn-uppercase btn-fullwidth btn-space"
                                            >
                                                <Translator content={this.buildButtonTextKey(printerBroken)} />
                                                <i className="icon icon-stayery-arrow-r" />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    buildButtonTextKey(printerBroken) {
        const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";
        const baseKey = manuelCardWorkflow ? "checkin.buttons_manual." : "checkin.buttons.";

        const brokenText = `encode`;
        const normalText = this.state.cardCount === 1 ? "getcard" : "getcards";
        return printerBroken ? `${baseKey}${brokenText}` : `${baseKey}${normalText}`;
    }

    buildHeadlineKey() {
        const isSecondRequest = this.props.location.state?.isSecondRequest ?? false;
        const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";

        const baseKey = manuelCardWorkflow ? "checkin.text_manual." : "checkin.text.";
        const secondSuffix = isSecondRequest ? "_second" : "";

        return `${baseKey}notforget${secondSuffix}`;
    }

    buildTextKey(twoCardsAllowed, printerBroken) {
        const isSecondRequest = this.props.location.state?.isSecondRequest ?? false;
        const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";

        const baseKey = manuelCardWorkflow ? "checkin.text_manual." : "checkin.text.";
        const secondSuffix = isSecondRequest ? "_second" : "";
        const roomType = twoCardsAllowed ? "roomnoticetwoCardsAllowed" : "roomnotice";
        const printerStatus = printerBroken ? "_brokenPrinter" : "";

        const key = `${baseKey}${roomType}${secondSuffix}${printerStatus}`;

        return i18next.exists(key) ? key : null;
    }

    buildPageTitleKey(twoCardsAllowed) {
        // redirectToThankYouOnFinish means probably that we are in the lostcard workflow
        const redirectToThankYouOnFinish = this.props.location.state?.redirectToThankYouOnFinish ?? false;
        const isSecondRequest = this.props.location.state?.isSecondRequest ?? false;
        const manuelCardWorkflow = localStorage.getItem("manuelCardWorkflow") === "true";

        const baseKey = "pageTitles.roominformationPage";

        const secondSuffix = isSecondRequest ? "_second" : "";
        if (redirectToThankYouOnFinish) {
            return `${baseKey}_lostcard${secondSuffix}`;
        } else {
            const manualSuffix = manuelCardWorkflow ? "_manual" : "";
            const twoCardsAllowedSuffix = twoCardsAllowed ? "_two" : "";

            return `${baseKey}${manualSuffix}${twoCardsAllowedSuffix}${secondSuffix}`;
        }
    }
}

export default RoomInformation;
